export default __webpack_public_path__ + "static/media/buy.2d69003e.jpeg";